import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  courses: Course[];
  loading?: boolean;
}


import { computed, defineComponent } from 'vue';

import { faEye } from '@icons/solid/faEye';

import CardLoadable from '@components/Cards/CardLoadable.vue';

import { dateFilter } from '@filters/date';
import { userLabelFilter } from '@filters/user-label';
import { Course, User } from '@models';
import { useRouter } from '@router';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardCurrentCourses: ComponentWithProps<Props>;
  }
}

/** ... */
const fields = [
  {
    key: 'operations',
    label: 'View',
    stickyColumn: true,
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'startDate',
    label: 'Start Date',
    formatter: (value: string) => dateFilter(value, 'MM/dd/yyyy'),
  },
  {
    key: 'endDate',
    label: 'End Date',
    formatter: (value: string) => dateFilter(value, 'MM/dd/yyyy'),
  },
  {
    key: 'teacher',
    formatter: displayUserLabel,
  },
  {
    key: 'teacherAssistant',
    formatter: displayUserLabel,
  },
];

/**
 * ...
 */
function displayUserLabel(value: User | null) {
  return value ? userLabelFilter(value) : '--';
}

const __default__ = defineComponent({ name: 'CardCurrentCourses' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    courses: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  courses: Course[];
  loading?: boolean;
};

/**
 * `CardCurrentCourses` component properties.
 */
const router = useRouter();



const currentCourses = computed(() => {
  // const today = new Date();

  // return this.courses.filter(({ endDate }) =>
  //   this.$utils.datePassed(endDate, today)
  // );

  return props.courses;
});

function goToCourse(course: Course) {
  const params = {
    organizationId: course.organization.id,
    courseId: course.id,
  };

  void router.push({ name: 'dashboardCourse', params });
}

return { __sfc: true,fields, displayUserLabel, router, props, currentCourses, goToCourse, faEye, CardLoadable }
}

})